import React, { PureComponent, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { login, redirectPage } from '../hooks/auth'
import PinField from "react-pin-field";

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = dispatch => ({
  login: (data, keep_login) => dispatch(login(data, keep_login)),
  redirectPage: () => dispatch(redirectPage())
});


class Login extends PureComponent {

  constructor(props) {
    super(props);
    this.inputsRef = [createRef(), createRef(), createRef(), createRef()];

    this.state = {
      name: "",
      date: null,
      month: null,
      year: null,
      pin: null,
      keep_login: false
    };
    this.props.redirectPage()
  }

  changeDateField = (e, index) => {
    var name = e.target.name
    var value = e.target.value
    if (parseInt(value) > e.target.max) {
      return false
    }

    if (value.length === 2 && index !== 3) {
      this.inputsRef[index + 1].current.focus();
    }
    this.setState({
      [name]: value,
      error: {
        ...this.state.error,
        'date_of_birth': null
      }
    })
  }

  handleChange = (e, index) => {
    if (e.target.value.length < 3) {
      this.setState({
        [e.target.name]: e.target.value
      })
      if (e.target.value.length === 2) {
        this.inputsRef[index + 1].current.focus();
      }
    }
  }
  handleBackspace = (event, index) => {
    if (event.key === "Backspace" && !event.target.value && index > 0) {
      this.inputsRef[index - 1].current.focus();
    }
    if (index != 0) {
      if (
        [46, 8, 9, 27, 13, 110, 190].includes(event.keyCode) ||
        (event.keyCode === 65 && event.ctrlKey === true) ||
        (event.keyCode === 67 && event.ctrlKey === true) ||
        (event.keyCode === 86 && event.ctrlKey === true) ||
        (event.keyCode === 88 && event.ctrlKey === true) ||
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {
        return;
      }

      if (
        (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        (event.keyCode < 96 || event.keyCode > 105)
      ) {
        event.preventDefault();
      }
    }
  };

  handlePinvalue = (value, name) => {
    this.setState({ [name]: value })
  }

  handleLogin = () => {
    var username = this.state.name + "-" + this.state.date + "-" + this.state.month + "-" + this.state.year
    if (username.length == 11 && this.state.pin.length == 4) {
      this.props.login({
        "username": username,
        "pin": this.state.pin
      }, this.state.keep_login)
    }
  }

  handlePasteStop = (event) => {
    event.preventDefault(); // Prevent paste
  };

  render() {
    return <Fragment>
      <NavbarComp />
      <div className="page-sections">
        <div className='login-wrap'>
          <Container>
            <div className='login-contents'>
              <h2 className='main-title-style'>LOGIN</h2>
              <Row>
                <Col lg={12}>
                  <Form.Group className="mb-4 mt-2" controlId="formGroupDOB">
                    <div className='dob-field'>
                      <Form.Control
                        value={this.state.name}
                        onChange={(e) => this.handleChange(e, 0)}
                        ref={this.inputsRef[0]}
                        onKeyDown={(e) => this.handleBackspace(e, 0)}
                        onPaste={this.handlePasteStop}
                        name='name'
                        type="text"
                        placeholder="IN" /> &nbsp;–&nbsp;
                      <Form.Control inputMode="numeric" type="number" value={this.state.date} onPaste={this.handlePasteStop} onChange={(e) => this.changeDateField(e, 1)} onKeyDown={(e) => this.handleBackspace(e, 1)} ref={this.inputsRef[1]} name="date" placeholder="DD" max="31" /> &nbsp;–&nbsp;
                      <Form.Control inputMode="numeric" type="number" value={this.state.month} onPaste={this.handlePasteStop} onChange={(e) => this.changeDateField(e, 2)} onKeyDown={(e) => this.handleBackspace(e, 2)} ref={this.inputsRef[2]} name="month" placeholder="MM" max="12" /> &nbsp;–&nbsp;
                      <Form.Control inputMode="numeric" type="number" value={this.state.year} onPaste={this.handlePasteStop} onChange={(e) => this.changeDateField(e, 3)} onKeyDown={(e) => this.handleBackspace(e, 3)} ref={this.inputsRef[3]} name="year" placeholder="YY" max="99" />
                    </div>
                    <span>Your initials and date of birth, e.g. John Smith born on 1st January 1970 means JS-01-01-70.</span>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12}>
                  <Form.Group className="mb-1 mt-1" controlId="formGroupPin">
                    <div className="pin-wrapper">
                      <span className='pin-class-dash-1'></span>
                      <span className='pin-class-dash-2'></span>
                      <PinField
                        autoComplete="new-password"
                        length={4}
                        onChange={(value) => this.handlePinvalue(value, "pin")}
                        validate={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                        inputProps={{ inputMode: "numeric" }}
                        ref={(inputElements) => {
                          if (inputElements) {
                            inputElements.forEach((input) => {
                              if (input && !input.placeholder) {
                                input.placeholder = "*";
                                input.type = "password";
                                input.max = 9;
                                input.inputMode = "numeric";
                              }
                            });
                          }
                        }}
                      />
                    </div>
                    <span>PIN you have entered with your registration.</span>
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <div className='form-submit-btn'>
                    <Button type="submit" onClick={this.handleLogin}>LOGIN</Button>
                  </div>
                </Col>
                <Col lg={12}>
                  <div key={`default-checkbox`} className="form-checkboxes">
                    <Form.Check checked={this.state.keep_login} onClick={(e) => this.setState({ keep_login: e.target.checked })} type="checkbox" id={`keep-login`} label={`Keep me logged in for 60 days`} />
                  </div>
                </Col>
                <Col lg={12}>
                  <a className='forgot-link' href="/forget-password" rel="nofollow">Forgotten your login?</a>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />

    </Fragment>
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
